module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Britannia-S1.d97da7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Britannia-S1.jpg
// module id = nZKk
// module chunks = 0